import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'
import {
  OrganizationalCategoriesResponse,
  Paginated,
  StaffRequest,
} from './types'

export interface OrganizationalCategories<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const organizationalCategories: OrganizationalCategories<
  StaffRequest,
  Paginated<OrganizationalCategoriesResponse>
> = (http, params) => {
  const {ClientID, PageNumber, PageSize} = params

  const path = '/v0/staff/organizationalcategories'

  const queryParams = []
  if (ClientID !== undefined) {
    queryParams.push(`clientid=${ClientID}`)
  }
  if (PageNumber !== undefined) {
    queryParams.push(`pagenumber=${PageNumber}`)
  }
  if (PageSize !== undefined) {
    queryParams.push(`pagesize=${PageSize}`)
  }
  const query = `?${queryParams.join('&')}`

  return http.request<Paginated<OrganizationalCategoriesResponse>>({
    method: 'GET',
    url: `${path}${query}`,
  })
}
